// extracted by mini-css-extract-plugin
export var boxItems = "_1s-1";
export var boxItemsLg = "_1s-2";
export var button = "_1s-7";
export var buttonHoverless = "_1s-9";
export var buttonLg = "_1s-8";
export var filterGroupBox = "_1s-0";
export var icon = "_1s-3";
export var iconSecondary = "_1s-6";
export var iconWrapper = "_1s-4";
export var iconWrapperLg = "_1s-5";
export var truncatedLabel = "_1s-a";